module.exports = __webpack_public_path__ + "img/9788959523610.9272ca18.jpg";